// const baseUrl = 'http://127.0.0.1:8088'   // 测试环境地址
const baseUrl = 'https://api.baibaitu.top' // 产线地址
// const baseUrl = process.env.VUE_APP_API_URL; // 使用环境变量

export { baseUrl }
